import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { companyInfo } from '../mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-xl border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            {/* Logo Image */}
            <img 
              src="https://i.postimg.cc/cCHSQ1GD/kiana-Photoroom.png" 
              alt="Company Logo" 
              className="h-12 w-auto object-contain"
            />
            {/* Company Name */}
            <div className="text-2xl font-bold text-amber-700">
              {companyInfo.name}
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-amber-700 transition-colors font-medium">
              Home
            </Link>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-amber-700 transition-colors font-medium">
              About
            </button>
            <button onClick={() => scrollToSection('projects')} className="text-gray-700 hover:text-amber-700 transition-colors font-medium">
              Projects
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-amber-700 transition-colors font-medium">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-amber-700 transition-colors font-medium">
              Contact
            </button>
            <Link to="/careers" className="text-gray-700 hover:text-amber-700 transition-colors font-medium">
              Careers
            </Link>
          </nav>

          {/* Contact Info */}
          <div className="hidden lg:flex items-center space-x-6">
            <a href={`tel:${companyInfo.contact.phone}`} className="flex items-center space-x-2 text-gray-700 hover:text-amber-700 transition-colors">
              <Phone size={18} />
              <span className="text-sm font-medium">{companyInfo.contact.phone}</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <Link to="/" onClick={() => setIsMenuOpen(false)} className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-left">
                Home
              </Link>
              <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-left">
                About
              </button>
              <button onClick={() => scrollToSection('projects')} className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-left">
                Projects
              </button>
              <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-left">
                Testimonials
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-left">
                Contact
              </button>
              <Link to="/careers" onClick={() => setIsMenuOpen(false)} className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-left">
                Careers
              </Link>
              <a href={`tel:${companyInfo.contact.phone}`} className="flex items-center space-x-2 text-gray-700 hover:text-amber-700 transition-colors pt-4 border-t border-gray-200">
                <Phone size={18} />
                <span className="text-sm font-medium">{companyInfo.contact.phone}</span>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
